var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHarmonylogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 220 60",
    style: {
      enableBackground: "new 0 0 220 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#E3001B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2755",
    transform: "translate(-114.247 -247.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8223",
    className: "st0",
    d: "M156.8,277.2c1.8-8.3,6.3-22.1,9.1-28h10.3c2.8,5.9,7.4,19.7,9.1,28v0.3h-8.8   c-0.3-1.6-0.8-3.5-1.2-5.6h-9c-0.5,2.1-0.9,4-1.2,5.6h-8.2L156.8,277.2z M167.8,265.7h6c-1.2-4.8-2.3-9.3-2.9-10.9   C170.3,256.4,169,260.8,167.8,265.7L167.8,265.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8224",
    className: "st0",
    d: "M188,249.2h12.4c6.9,0,11.2,2.8,11.2,9.7c0,3.8-1.2,6-4.3,8.1c2.4,1.9,5,6.5,6.1,10.1v0.3h-8.3   c-0.8-2.9-3.2-6.9-5.3-8.3h-3.5v8.3H188L188,249.2z M199.2,263.3c3.1,0,4.1-1,4.1-4.1c0-3-1.2-3.8-4.1-3.8h-3v8L199.2,263.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8225",
    className: "st0",
    d: "M215.5,249.2h7.7l6.9,10.9l7.2-10.9h7.7v28.3h-8.3v-15.8l-5.9,8.1h-1.8l-5.3-8.1v15.8h-8.2   V249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8226",
    className: "st0",
    d: "M248.2,262.5c0-8.7,4.6-13.6,13.3-13.6c8.7,0,13.2,4.9,13.2,13.6v1.7c0,8.7-4.6,13.6-13.2,13.6   c-8.7,0-13.3-4.9-13.3-13.6V262.5z M261.5,271.3c4.3,0,5-2.8,5-7.1v-1.7c0-4.3-0.8-7.1-5-7.1s-5,2.8-5,7.1v1.7   C256.5,268.5,257.2,271.3,261.5,271.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8227",
    className: "st0",
    d: "M278,249.2h7l10,14.7v-14.7h8.3v28.3h-7.1l-10-14.7v14.7H278L278,249.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8228",
    className: "st0",
    d: "M314.7,267l-9.3-17.5v-0.3h8.7l5.2,11.3l5.2-11.3h7.5v0.3l-9,17.2v10.7h-8.3L314.7,267z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2753",
    transform: "translate(127.107 286.065)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2751",
    transform: "translate(0 0.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8229",
    className: "st0",
    d: "M1.7,1.6h5.7c3.7,0,5.3,2,5.3,5.7s-1.8,6.1-5.7,6.1H3.9v5.9H1.7L1.7,1.6z M7,11.4     c2.9,0,3.5-1.7,3.5-4.1c0-2.6-0.7-3.8-3.3-3.8H3.9v7.9L7,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8230",
    className: "st0",
    d: "M13.5,19.1c1.6-6.7,4.2-14.4,5.9-17.5h2.9c1.6,3.1,4.3,10.7,5.9,17.5v0.2h-2.2     c-0.4-1.4-0.7-2.9-1.1-4.3h-8.1c-0.4,1.5-0.8,2.9-1.1,4.3h-2.1V19.1z M17.2,13h7c-0.9-3.3-2-6.5-3.5-9.6     C19.3,6.5,18.1,9.7,17.2,13z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8231",
    className: "st0",
    d: "M30.9,1.6h5.7c3.7,0,5.3,1.6,5.3,5.3c0.2,2.2-1.1,4.3-3.2,5c1.9,2,3.4,4.4,4.3,7.1v0.2h-2.3     c-0.9-2.5-2.3-4.7-4.1-6.6h-3.5v6.6h-2.2V1.6z M36,10.7c2.8,0,3.7-1.6,3.7-3.8c0-2.6-0.9-3.4-3.3-3.4h-3.3v7.2L36,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8232",
    className: "st0",
    d: "M49.4,3.5h-5.5V1.6h13.2v1.9h-5.5v15.7h-2.2V3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8233",
    className: "st0",
    d: "M59.9,1.6h1.5l9.6,13.1V1.6h2.2v17.6h-1.5L62.1,6.2v13.1h-2.2L59.9,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8234",
    className: "st0",
    d: "M77.6,1.6h9.9v1.9h-7.7v5.4h7v2h-7v3.8c0,1.8,0.9,2.7,2.4,2.7h5.3v1.9h-5.2     c-3.1,0-4.8-1.5-4.8-4.8L77.6,1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8235",
    className: "st0",
    d: "M91.2,1.6h5.7c3.7,0,5.3,1.6,5.3,5.3c0.2,2.2-1.1,4.3-3.2,5c1.9,2,3.4,4.4,4.3,7.1v0.2h-2.3     c-0.9-2.5-2.3-4.7-4.1-6.6h-3.5v6.6h-2.2L91.2,1.6z M96.4,10.7c2.8,0,3.7-1.6,3.7-3.8c0-2.6-0.9-3.4-3.3-3.4h-3.3v7.2L96.4,10.7z     "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2752",
    transform: "translate(110.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8236",
    className: "st0",
    d: "M1.7,17h0.2c1.4,0.4,2.9,0.7,4.4,0.7H7c2.2,0,3.7-0.8,3.7-3c0-1.9-1-2.5-2.6-2.9l-2.4-0.6     C4,10.6,1.9,9.5,1.9,6.4c0-2.8,2.2-4.8,5.7-4.8h0.5c1.4,0,2.7,0.3,4,0.7v1.9H12c-1.3-0.4-2.5-0.6-3.9-0.7H7.6     c-2.2,0-3.5,0.8-3.5,2.8c0,1.8,1.2,2.3,2.6,2.8l2.3,0.7c1.8,0.5,4,1.5,4,4.9c0,3-2.2,5-5.9,5H6.3c-1.6-0.1-3.1-0.3-4.6-0.7     L1.7,17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8237",
    className: "st0",
    d: "M15.6,9.5c0-5.2,3.3-7.9,8.5-7.9c1.4,0,2.8,0.3,4,0.8v4h-2V3.8c-0.8-0.2-1.6-0.3-2.4-0.3     c-3.3,0-5.9,1.7-5.9,6v2.2c0,3.9,2,6,5.5,6h1.1c1.2,0,2.4-0.3,3.5-0.7h0.2v1.8c-1.2,0.5-2.4,0.8-3.7,0.8h-1.1     c-5.3,0-7.7-3.3-7.7-7.9L15.6,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8238",
    className: "st0",
    d: "M31.7,1.8h2.2v7.4h8.7V1.8h2.2v17.6h-2.2v-8.4h-8.7v8.4h-2.2V1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8239",
    className: "st0",
    d: "M48.4,9.9c0-5.2,2.6-8.3,7.4-8.3s7.3,2.9,7.3,8.3v1.5c0,5.2-2.6,8.3-7.3,8.3     s-7.4-2.9-7.4-8.3V9.9z M55.8,17.7c3.4,0,5.2-1.9,5.2-6.4V9.9c0-4.4-1.7-6.4-5.2-6.4s-5.2,1.9-5.2,6.4v1.5     C50.7,15.8,52.4,17.7,55.8,17.7L55.8,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8240",
    className: "st0",
    d: "M66.1,9.9c0-5.2,2.6-8.3,7.4-8.3s7.3,2.9,7.3,8.3v1.5c0,5.2-2.6,8.3-7.3,8.3     s-7.4-2.9-7.4-8.3V9.9z M73.5,17.7c3.4,0,5.2-1.9,5.2-6.4V9.9c0-4.4-1.7-6.4-5.2-6.4s-5.2,1.9-5.2,6.4v1.5     C68.3,15.8,70,17.7,73.5,17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8241",
    className: "st0",
    d: "M84.5,1.8h2.2v13.1c0,1.8,0.9,2.7,2.4,2.7h5v1.9h-4.8c-3.1,0-4.8-1.6-4.8-4.8V1.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2754",
    transform: "translate(127.107 247.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8242",
    className: "st0",
    d: "M18.8,1.6v28.3H27V1.6H18.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8243",
    className: "st0",
    d: "M1.7,15.7v14.1h8.2V1.6H1.7V15.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8244",
    className: "st1",
    d: "M115.9,259.3l24.7,3.3l0.7-2.1l0.7,2.1h2.2l-1.8,1.3l0.7,2.1l-1.8-1.3L130.3,277l11.1-8.1   l7.7,5.7l-2.8-9.4l2.5-1.9l4-3.1l1.1-0.9h-9.4l-3-9.7l-3,9.7L115.9,259.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarmonylogo);
export default __webpack_public_path__ + "static/media/harmonylogo.13a9248a69b6bd40935ab8751f30aa90.svg";
export { ForwardRef as ReactComponent };